import { FC, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';
import type { RequestedFileFulfillmentStatus } from 'common/types/files/files';
import type { DocumentChecklistItem } from '../OnboardingEmailModal.types';

export type MarkDocumentNaDialogProps = {
  item: DocumentChecklistItem | null;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: (
    item: DocumentChecklistItem,
    status: RequestedFileFulfillmentStatus,
    note: string | null
  ) => Promise<void>;
};

const MarkDocumentNaDialog: FC<MarkDocumentNaDialogProps> = ({
  item,
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const [status, setStatus] = useState<RequestedFileFulfillmentStatus>('not_applicable');
  const [note, setNote] = useState('');

  const handleClose = () => {
    setStatus('not_applicable');
    setNote('');
    onClose();
  };

  return (
    <Dialog open={Boolean(item)} onClose={handleClose} disablePortal maxWidth="xs" fullWidth>
      <DialogTitle>Mark document as not applicable</DialogTitle>
      <DialogContent>
        <TextField
          select
          fullWidth
          margin="dense"
          label="Status"
          value={status}
          onChange={event => setStatus(event.target.value as RequestedFileFulfillmentStatus)}
          id="onboarding-mark-fulfillment-status"
        >
          <MenuItem value="not_applicable">Not applicable</MenuItem>
          <MenuItem value="not_available">Not available</MenuItem>
        </TextField>
        <TextField
          fullWidth
          margin="dense"
          label="Note"
          value={note}
          onChange={event => setNote(event.target.value)}
          multiline
          minRows={2}
          placeholder="Optional note (e.g. company has no convertible notes)"
          id="onboarding-mark-fulfillment-note"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={async () => {
            if (!item) {
              return;
            }
            await onConfirm(item, status, note.trim() || null);
            setStatus('not_applicable');
            setNote('');
          }}
          disabled={isSubmitting || !item}
          id="onboarding-confirm-mark-fulfillment-button"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarkDocumentNaDialog;
